"use strict";

import Select from './select';
import Css from './css';

const showDetailsRowButton = Select.all('[data-show-details-row]');

function WidthChange(mq) {
    if (mq.matches) {
        var activeDetailRows = Select.all('.active[data-details-row-id]');
        if(activeDetailRows !== null){
            for(var i= 0, len=activeDetailRows.length; i<len; i++){
                Css.removeClass(activeDetailRows[i], 'active');
            }
        }
    }
}

export default {
    showDetailsRowButton: Select.all('[data-show-details-row]'),
    init: function(){
        if(this.showDetailsRowButton !== null) {
            for (var i = 0, len = this.showDetailsRowButton.length; i < len; i++) {
                this.showDetailsRowButton[i].addEventListener('click', function (e) {
                    e.preventDefault();
                    var detailsRowId = this.getAttribute('data-show-details-row');
                    var detailsRow = Select.one('[data-details-row-id="' + detailsRowId + '"]');
                    if (Css.hasClass(this, 'active')) {
                        Css.removeClass(detailsRow, 'active');
                        Css.removeClass(this, 'active');
                    }
                    else {
                        Css.addClass(detailsRow, 'active');
                        Css.addClass(this, 'active');
                    }
                }, false);
            }
            if (matchMedia) {
                var mq = window.matchMedia("(min-width: 1024px)");
                mq.addListener(WidthChange);
                WidthChange(mq);
            }
        }
    }
};
